import { render, staticRenderFns } from "./zsbToBuy.vue?vue&type=template&id=3f93ebc6&scoped=true&"
import script from "./zsbToBuy.vue?vue&type=script&lang=js&"
export * from "./zsbToBuy.vue?vue&type=script&lang=js&"
import style0 from "./zsbToBuy.vue?vue&type=style&index=0&id=3f93ebc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93ebc6",
  null
  
)

export default component.exports